import React, { useEffect, useState } from "react";
import "./Banner.scss";
import BgRing from "../../assests/images/banner-bg-ring.svg";

import TrustPilot from "../../assests/images/trustpilot.svg";
import BlackCheckMark from "../../assests/images/black-checkmark.svg";
import PadLock from "../../assests/images/padlock.svg";
import { useNavigate } from "react-router";
const Banner = () => {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState(null);

  const handleButtonClick = (text) => {
    setActiveButton(text);
    if (text.toUpperCase() === "MORE THAN 2 YEARS AGO") {
      navigate("/form/sorry");
    } else {
      localStorage.setItem("selectedButtonText", text);
      navigate("/form");
    }
  };
  useEffect(() => {
    if (activeButton !== null) {
      const timer = setTimeout(() => {
        navigate("/form");
        localStorage.setItem("selectedButtonText", activeButton);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [activeButton, navigate]);
  return (
    <div className="b_body">
      <section className="banner container1286">
        <figure className="banner__ring">
          <img src={BgRing} alt="" srcSet="" />
        </figure>
        <div className="wrapper ">
          <div className="banner__details">
            <div className="banner__details-rating">
              <span>
                <strong>Excellent</strong>
              </span>
              <span>
                <img
                  src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-4.5.svg"
                  alt=""
                  width={96}
                  height={21}
                />
              </span>
              <span>
                <strong>1,378+</strong> Reviews On
              </span>
              <span>
                <img src={TrustPilot} alt="" />
              </span>
            </div>
            <div className="banner__details-header">
              <h1>
                <span className="banner-different">See If You Qualify</span> For
                a <span className="break">Free Personal Injury Claim</span>
                <span className="break">
                  {" "}
                  Assessment{" "}
                  <span className="n2 banner-different ">In 30 Seconds</span>
                </span>
              </h1>
            </div>
            <div className="banner__details-list">
              <li>
                <figure>
                  <img src={BlackCheckMark} alt="" />
                </figure>
                <div className="listPoints">
                  <strong>Physical injuries</strong>, may qualify.
                </div>
              </li>
              <li>
                <figure>
                  <img src={BlackCheckMark} alt="" />
                </figure>
                <div>
                  Complete confidentiality{" "}
                  <strong>—your job is never at risk.</strong>
                </div>
              </li>
              <li>
                <figure>
                  <img src={BlackCheckMark} alt="" />
                </figure>
                <div>
                  <strong>Pay nothing&nbsp;</strong> for our service.
                </div>
              </li>
            </div>
            <div className="banner__details-review desk-show">
              <p>
                National Injury Claimline Ltd is a claims management company and
                receive payments from our partnered law firms. We offer a free
                claim assessment and will connect you to a specialist law firm
                if we identify a potential claim that our law firms can help
                with.
              </p>
            </div>
          </div>
          <div className="banner__card">
            <h2>How long ago did the accident occur?</h2>
            <p>
              This includes any minor accident that resulted in a physical
              injury
            </p>
            <div className="banner__card-buttons">
              {["Less than 2 years ago", "More than 2 years ago"].map(
                (text, index) => (
                  <div className="button" key={index}>
                    <button
                      onClick={() => handleButtonClick(text)}
                      className={activeButton === text ? "active" : ""}
                    >
                      {text}
                    </button>
                  </div>
                )
              )}
            </div>
            <p>
              <span>
                <img
                  src={PadLock}
                  alt=""
                  width={12}
                  height={14}
                  className="pad-lock"
                />
              </span>
              <span className="safe_secure">
                Your Information is safe & secure
              </span>
            </p>
          </div>
          <div className="banner__details-review mob-show">
            <p>
              National injury claimline ltd is a claims management company and
              receive payments from our partnered law firms. we offer a free
              claim assessment and will connect you to a specialist law firm if
              we identify a potential claim that our law firms can help with.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Banner;
